import * as React from 'react';
import {
    List,
    Datagrid,
    Filter,
    TextField,

    TextInput,
    SelectInput,
    SimpleForm,
    Edit,
    EditButton,
    useRedirect,
    TopToolbar,
    Button,
    SimpleShowLayout,
    Show,
    FunctionField,
    DateField,
} from 'react-admin';
import { Box, Chip } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { UpLoadFile } from '../components/custom/UpLoadFile';

const useTxtData = {
    page: {
        tableName: '代办预约',
    },
    table: {
        id: 'ID',
        ApplicantName: '申请人',
        ApplicantMobile: '联系电话',
        AppointmentTime: '预约时间',
        Address: '地址',
        ServiceType: '服务类型',
        Description: '描述',
        Attachments: '申请附件',
        Status: '状态',
        AgentName: '代办员',
        CollectionInfo: '取件信息',
        CollectionAttachments: '取件附件(隐私)',
        ResultDescription: '办理结果',
        ResultAttachments: '结果附件',
        ExpressNumber: '快递单号',
        CreateTime: '提交时间',
    }
};

const statusChoices = [
    { id: 0, name: '待核验' },
    { id: 1, name: '已收件' },
    { id: 2, name: '办理中' },
    { id: 3, name: '已结办' },
    { id: 4, name: '已寄送' },
    { id: 5, name: '已取消' },
];

const StatusField = ({ record }) => {
    const status = statusChoices.find(s => s.id === record.Status);
    return <Chip label={status ? status.name : '未知'} color={record.Status === 3 ? "primary" : "default"} />;
};

const GovServiceAppointmentFilters = (props) => {
    return (
        <Filter {...props}>
            <TextInput label="名称/电话/业务" source="key" resettable alwaysOn />
            <SelectInput label="状态" source="Status" choices={statusChoices} alwaysOn />
        </Filter>
    );
};

export const GovServiceAppointmentList = (props) => {
    return (
        <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} filters={<GovServiceAppointmentFilters />} bulkActionButtons={false}>
            <Datagrid>
                <TextField label={useTxtData.table.id} source="id" />
                <TextField label={useTxtData.table.ApplicantName} source="ApplicantName" />
                <TextField label={useTxtData.table.ApplicantMobile} source="ApplicantMobile" />
                <TextField label={useTxtData.table.ServiceType} source="ServiceType" />
                <StatusField label={useTxtData.table.Status} source="Status" />
                <TextField label={useTxtData.table.AgentName} source="AgentName" />
                <DateField label={useTxtData.table.CreateTime} source="CreateTime" />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export const GovServiceAppointmentEdit = (props) => {
    const redirect = useRedirect();
    const Actions = (props) => (
        <TopToolbar>
            <Button label="返回列表" onClick={() => redirect(props.basePath)} variant="text">
                <ArrowBack />
            </Button>
        </TopToolbar>
    );

    return (
        <Edit title={'办理' + useTxtData.page.tableName} {...props} actions={<Actions />}>
            <SimpleForm>
                <Box display="flex flex-col" width="100%">
                    <Box flex={1} mr={2}>
                        <TextField label={useTxtData.table.ApplicantName} source="ApplicantName" />
                        <TextField label={useTxtData.table.ApplicantMobile} source="ApplicantMobile" />
                        <TextField label={useTxtData.table.Address} source="Address" />
                        <TextField label={useTxtData.table.Description} source="Description" />
                    </Box>
                    <Box flex={1}>
                        <SelectInput label={useTxtData.table.Status} source="Status" choices={statusChoices} />
                        <TextInput label={useTxtData.table.AgentName} source="AgentName" />
                        <TextInput label={useTxtData.table.ExpressNumber} source="ExpressNumber" />
                    </Box>
                </Box>
                <TextInput label={useTxtData.table.CollectionInfo} source="CollectionInfo" multiline fullWidth />
                <UpLoadFile multiple label={useTxtData.table.CollectionAttachments} source="CollectionAttachments" />
                <TextInput label={useTxtData.table.ResultDescription} source="ResultDescription" multiline fullWidth />
                <UpLoadFile multiple label={useTxtData.table.ResultAttachments} source="ResultAttachments" />
            </SimpleForm>
        </Edit>
    );
};
